module.exports = __webpack_public_path__ + "static/media/page40.e9f7b0ba.jpg";